// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 661) return "static/chunks/661-829b44084f53c376.js";
	if (chunkId === 327) return "static/chunks/327-111282040cbf22e0.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"418":"3fc79a20c6341753","536":"a82664a3f4362470"}[chunkId] + ".js";
};